import * as React from 'react';
import { Row, Col } from 'antd';
import { observer } from 'mobx-react';

import { TextView } from 'src/core/ui/text.view';
import { BooleanView } from 'src/core/ui/boolean.view';
import { AllotmentEditorController } from 'src/app/products/allotment/parts/allotment-editor.controller';
import { ProductTypeEditorController } from 'src/app/products/products/parts/product-type-editor.controller';
import { ProductEditorController } from 'src/app/products/products/parts/product-editor.controller';
import { SupplierEditorController } from 'src/app/products/suppliers/parts/supplier-editor.controller';
import { ProductCategoryEditorController } from 'src/app/products/product-categories/parts/product-category-editor.controller';

interface AllotmentGeneralPartViewProps extends ComponentViewProps<AllotmentItem> {
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	fromContract?: boolean,
	defaultLanguaje: string,
	productTypeText?: string,
	categoryDisplayName?: string
	productDisplayName?:string
}

interface State {

	productType?: number,
	categoryProductId?: number
}

@observer
export class AllotmentGeneralPartView extends React.Component<AllotmentGeneralPartViewProps, State> {
	constructor(props: Readonly<AllotmentGeneralPartViewProps>) {
		super(props);
		this.state = {
			productType: this.props.model.productType,
			categoryProductId: this.props.model.categoryId
		};
	}
	render() {
		const { model, mode } = this.props;
		return (
			<React.Fragment>
				<Row gutter={16}>
					<Col xs={24} lg={12}>
						<TextView
							required
							onGetErrorMessage={() => model.validate(false, 'name')}
							label="Name"
							mode={mode}
							value={model.name}
							onChanged={(value) => {
								model.name = value;
							}}
						/>
					</Col>
					<Col xs={24} lg={12}>
						<AllotmentEditorController
							label="Parent allotment"
							mode={mode}
							onChanged={(value) => { model.parentAllotmentId = value }}
							value={model.parentAllotmentId}
							setBusy={this.props.setBusy}
						/>
					</Col>
				</Row>
				<Row gutter={16}>
					{
						this.props.fromContract == false && <Col xs={24} lg={12}>
							<ProductTypeEditorController
								label='Product Type'
								required
								mode={this.props.mode}
								onChanged={(value) => {
									model.productType = value;
									model.productId = undefined;
									model.categoryId = undefined;
									this.setState({
										productType: model.productType,
										categoryProductId: model.categoryId,
									});

								}}
								value={this.state.productType}
								setBusy={this.props.setBusy}
								options={[
									{ value: 0, label: 'General' },
									{ value: 1, label: 'Accomodation' },
									{ value: 2, label: 'Car Rent' },
									{ value: 3, label: 'Transfer' },
									{ value: 4, label: 'Flight' },
									{ value: 5, label: 'Room' }
								]}
							/>
						</Col>
					}
					{
						this.props.fromContract == false && <Col xs={24} lg={12}>
							<ProductCategoryEditorController
								mode={this.state.productType != null && this.props.mode == 'edit' ? 'edit' : 'display'}
								onChanged={(value) => {
									model.categoryId = value != null ? value.id : null;
									model.productId = undefined;
									this.setState({
										categoryProductId: model.categoryId,

									});
								}}
								value={this.state.categoryProductId}
								productType={this.state.productType}
								setBusy={this.props.setBusy}
							/>
						</Col>
					}
					{
						this.props.fromContract == true && <Col xs={24} lg={12}>
							<TextView
								label="Product Type"
								mode={"display"}
								value={this.props.productTypeText}
							/>
						</Col>
					}
					{
						this.props.fromContract == true && <Col xs={24} lg={12}>
							<TextView
								label="Category"
								mode={"display"}
								value={this.props.categoryDisplayName}
							/>
						</Col>
					}
				</Row>
				<Row gutter={16}>
					{
						this.props.fromContract == false && <Col xs={24} lg={12}>
							<ProductEditorController
								label="Product"
								required
								mode={this.state.productType != null && this.state.categoryProductId != null && this.props.mode == 'edit' ? 'edit' : 'display'}
								onChanged={(value) => {
									model.productId = value ? value.id : null;
								}}
								value={model.productId}
								categoryId={this.state.categoryProductId}
								productType={this.state.productType}
								setBusy={this.props.setBusy}
							/>
						</Col>
					}
					{
						this.props.fromContract == true && <Col xs={24} lg={12}>
							<TextView
								label="Product"
								mode={"display"}
								value={this.props.productDisplayName}

							/>
						</Col>
					}
					<Col xs={24} lg={12}>
						<SupplierEditorController
							label="Supplier"
							required
							mode={this.props.fromContract == false && this.props.mode == 'edit' ? 'edit' : 'display'}
							onChange={(value: SupplierSummary) => {
								model.supplierId = value ? value.id : null;
								// this.props.avalabilities[model.supplierId.toString()] = model;
							}}
							value={model.supplierId}
							setBusy={this.props.setBusy}
							supplierType={this.state.productType == 2 ? 1 : 0}
							productId={model.productId}
						/>
					</Col>
					<Col xs={24} lg={6}>
						<BooleanView
							value={model.byDefault}
							label='By Default'
							onChanged={newVal => model.byDefault = newVal}
							mode={this.props.mode}
						/>
					</Col>
				</Row>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/allotment/form/parts/allotment-general.view.tsx